import { axiosInstance } from 'services/axiosInstance'

const getAccountAdviseInfos = (customerPhone?: string): Promise<any> =>
  axiosInstance.get(
    `/home-loan-be/api/v1/ldp/loan-applications/check-exist?customerPhone=${customerPhone}`
  )

export { getAccountAdviseInfos }
